<template>
  <div>

    <help :text="$t('help.plan_create')" :title="$t('help.plan_create_title')"/>

    <div :key="$store.getters['resource/currentResource'].key">
      <plan-view />
    </div>
  </div>
</template>

<script>
  import PlanView from "./PlanView.vue";

  export default {
    components: {
      PlanView
    },
    middleware: 'auth',
    name: 'PlanCreation'
  }
</script>